// extracted by mini-css-extract-plugin
export default {"root":"StatisticRow_root__5rKJJ","rightShadow":"StatisticRow_rightShadow__bV80s"};